import { CSSProperties } from "react"
import { Blocks, Header, app } from ".."
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Service } from "./service"
import { Categories } from "./categories"
import { Article } from "./article"
import { SearchResults } from "./searchresults"
import { Redirect } from "./redirect"
import MapPage from "./mapPage"
import ContactUs from "./contactUs"
import Analytics from "./analytics"
import { LanguageSelectionModal } from "./language-selection-modal"


export function Page() {

  if (app.state.status != "ready") return null
  const styles: CSSProperties = {
    gridTemplateRows: "auto 1fr",
  }

  if (app.page.color) styles.color = app.page.color
  if (app.page.bgcolor) styles.backgroundColor = app.page.bgcolor

  const googletag = app.googletag ?? []

  return <div className="grid min-w-0 max-w-full w-full" style={{ ...styles, gridTemplateColumns: "minmax(0, 1fr)" }}>
    <BrowserRouter>
      <Analytics googleAnalyticsIds={googletag} />
      <LanguageSelectionModal />
      <Header />
      <main className="min-w-0 max-w-full w-full overflow-x-clip">
        <Routes>
          <Route path="/:locale?" element={<Blocks />} />
          <Route path="/:locale?/services/:id?" element={<Service />} />
          <Route path="/:locale?/articles/:id?" element={<Article />} />
          <Route path="/hc/:locale?/articles/:id?" element={<Article />} />
          <Route path="/:locale?/categories/:categoryid?/:sectionid?" element={<Categories />} />
          <Route path="/:locale?/search-results" element={<SearchResults />} />
          <Route path="/:locale?/sections/:sectionid" element={<Redirect />} />
          <Route path="/:locale?/service-map" element={<MapPage />} />
          <Route path="/:locale?/contact-us" element={<ContactUs />} />
        </Routes>
      </main>
    </BrowserRouter>
  </div>
}

